import {Injectable} from '@angular/core';
import {AbstractAdvTechService} from '../abstract-advtech.service';

/**
 * Abstract service for the urs calls
 * @abstract
 * @extends AbstractAdvTechService
 */
@Injectable()
export abstract class AbstractUrsService extends AbstractAdvTechService {

}



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/urs/abstract-urs.service.ts